/**
 * Imports
 */
import { createSelector } from '@reduxjs/toolkit';

import { VibrantlyState } from 'store/types';

/**
 * Selectors
 */
export const rootSelector = (state: VibrantlyState) => state.user;

export const maybeUserSelector = createSelector(
  [rootSelector],
  (root) => root.user,
);

export const userSelector = createSelector(
  [rootSelector],
  (root) => root.user!,
);
export const hasFinanceSelector = createSelector(
  [rootSelector],
  (root) => root.user?.userRoles.includes('admin') || root.user?.userRoles.includes('finance'),
);
